<template>
    <div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <h1 style="padding: 0 25px">Coming Soon</h1>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';

export default defineComponent({
    name: 'ComingSoon',
    components: {
        
    },
    data() {
        return {
            
        }
    },
    async created() {
        this.$store.state.routeLoaded = true;
    },
});
</script>